import { render } from "./ResidenceBreadcrumb.vue?vue&type=template&id=6c60cc13"
import script from "./ResidenceBreadcrumb.vue?vue&type=script&lang=js"
export * from "./ResidenceBreadcrumb.vue?vue&type=script&lang=js"

import "./ResidenceBreadcrumb.vue?vue&type=style&index=0&id=6c60cc13&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__